/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import {
  Component,
  OnInit,
  ViewChild,
  HostListener,
  ChangeDetectorRef,
  PLATFORM_ID,
  Inject,
  OnDestroy,
  OnChanges
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProductDialogComponent } from '../../shared/components/products-carousel/product-dialog/product-dialog.component';
import { ListsSandbox } from '../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../core/service/config.service';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProductFilterComponent } from 'src/default/pages/products/product-filter/product-filter.component';
import { ListsService } from 'src/core/lists/lists.service';
import { ProductCompareSandbox } from '../../../core/product-compare/product-compare.sandbox';
import { ProductCompareService } from 'src/core/product-compare/product-compare.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';

// const routes: Routes = [
//   { path: 'products/productdetails/:productSlug', component: ProductDetailsComponent },
//   // other routes...
// ];
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})


export class ProductsComponent implements OnInit, OnDestroy {

  public selectedCompare = [];
  public selected = [];
  public isselected: any;
  check = true;
  isLoading: boolean = false
  isMainCategoryLoading = false;
  // decorator
  @ViewChild('sidenav') sidenav: any;
  public showCompose = false;
  // side nav
  public sidenavOpen = true;

  // card view
  public viewType = 'list';
  public viewCol = 25;
  public sortings: Array<any>;
  public sortData: any = 'Price Low To High';
  condition: any;
  Category: any = {};
  SideCategory: any = {};
  searchText: string = '';
  // parameters for product list
  public startKey = 0;
  public viewOrder = 'ASC';
  public keyword = '';
  public categoryId = '';
  public categorySlug = '';
  public brand: any = '';
  public priceFrom = 0;
  public priceTo = '';
  // pagination
  public pagesize: any = 20;
  public index: any = 0;
  // load image path
  public imagePath: string;
  // product list
  public isClicked: any = [];
  public isProduct: boolean;
  public queryParams: any;
  // discount price
  public discountPrice = 20;
  public fiftyPercent = 50;
  public subscription: Array<Subscription> = [];
  storename = environment.storename;
  public imageUrls:any;

  public isSpecialDeal = false;
  public specs: any;
  brandIdarray: any[] = [];
  brands: any;
  subCategory: any[] = [];
  rawSubCategory: any[] = [];
  full_category: any[] = [];
  specialDealValue: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private router: Router,
    public listSandbox: ListsSandbox,
    private configService: ConfigService,
    private changeDetectRef: ChangeDetectorRef,

    private listsService: ListsService,
    public compareSandbox: ProductCompareSandbox,
    public productCompareService: ProductCompareService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // subscribe route params
     this.specialDealValue = localStorage.getItem('specialdeal')
    console.log("constratorsssssss")
    this.subscription.push(
      this.activatedRoute.queryParams.subscribe(query => {
        console.log('HIIIIIIIIIIIIIIIII')
        if (query['keyword']) {
          this.keyword = query['keyword'];
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('keywordData', query['keyword']);
            this.keyword = localStorage.getItem('keywordData');
          }
          this.getProductList(this.startKey, this.viewOrder, '');
        }
        if (query['brand']) {
          this.brand = query['brand'];
          this.getProductList(this.startKey, this.viewOrder, '');
        }
      })
    );

    this.subscription.push(
      this.listSandbox.categoryLevel$.subscribe(item => {

        if (item != null) {
          for (let obj of item) {
            if (obj.name == "Special Deals") {
              this.isSpecialDeal = true;
            }
          }
        }
        console.log("item ===> :", item)
        console.log("isSpecial : ", this.isSpecialDeal)
      })
    );
    this.specs = '';
    this.subscription.push(
      this.activatedRoute.params.subscribe(param => {
        this.queryParams = param;
        //  this.brand = '';
        // if route params contains id assign id to the parameter categoryId
        if (this.queryParams.id) {
          this.startKey = 0;
          this.index = 0;
          if (this.queryParams.id === 'All' && this.brand === '') {
            this.isClicked = [];
            this.brand = '';
            this.keyword = '';
            this.categoryId = '';
            this.categorySlug = '';
            this.getProductList(this.startKey, this.viewOrder, this.categorySlug);
          } else if (this.queryParams.id === 'All' && this.brand !== '') {
            this.isClicked = [];
            this.brand = this.brand;
            this.keyword = '';
            this.categoryId = '';
            this.categorySlug = '';
            this.getProductList(this.startKey, this.viewOrder, this.categorySlug);
          } else {
            this.isClicked = [];
            this.isClicked[this.queryParams.id] = true;
            this.categoryId = this.queryParams.id;
            this.categorySlug = this.queryParams.id;

            this.getProductList(this.startKey, this.viewOrder, this.categorySlug);
          }
        }
      })
    );
  }

  // initially remove local storage and calls listSandbox getSettings
  ngOnInit() {
    console.log('HIIIIIIIIIIIIIIIII')

    this.imageUrls = this.configService.getImageUrl();
    
    const specs: any = localStorage.setItem('specs', '');
    this.specs = '';
    this.Category = {};

    if (this.categorySlug == "special-deals") {
      this.isSpecialDeal = true;
    }
    const local = JSON.parse(localStorage.getItem('compareId'));
    if (local) {
      this.selected = local;
      this.selectedCompare = local;

    } else {
      this.selected = [];

    }

    /* --> enable this by Alex
    if (this.categorySlug) {
      console.log('calling categroy --->')
      this.categoryFilter(this.categorySlug);
      this.getCategories()
    }
    if (!this.queryParams.id && this.keyword === '') {
      this.getProductList(this.startKey, this.viewOrder, '');
    }
    */

    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('fromPrice');
      localStorage.removeItem('priceTo');
    }
    // this.listSandbox.getSettings();
    this.sortings = [
      { order: 'Price Low To High', value: 'ASC' },
      { order: 'Price High To Low', value: 'DESC' }
    ];
    // this.imagePath = this.configService.get('resize').imageUrl;
    this.imagePath = this.configService.getImageUrl();
    this.changeDetectRef.detectChanges();
    if (window.innerWidth < 960) {
      this.sidenavOpen = false;
    }
    if (window.innerWidth < 1280) {
      this.viewCol = 33.3;
    }
    this.brandsList()
  }

  public getCategories() {


  }
  isCategoryEmpty(): boolean {
    return Object.keys(this.Category).length === 0;
  }

  brandsList() {
    const params = {
      storename: environment.storename,
      selected: environment.settingsId
    };
    this.listSandbox.getManufacturerList(params);
    console.log(this.listSandbox.getManufacturerList(params))
  }



  public selectBrand(event: MatCheckboxChange, brandId) {
    console.log(brandId)
    if (event.checked) {
      // Add the manufacturerId to the array
      this.brandIdarray.push(brandId);
    } else {
      // Remove the manufacturerId if the checkbox is unchecked
      this.brandIdarray = this.brandIdarray.filter((id) => id !== brandId);
    }

    console.log(this.brandIdarray)
    console.log('brandIDArray', this.brandIdarray)
    const params: any = {};
    params.refresh = false;
    if (this.brandIdarray.length > 0) {
      const brands = this.brandIdarray.toString();
      params.manufacturerId = brands;
    } else {
      params.manufacturerId = '';
    }
    params.keyword = this.keyword;
    params.Specs = this.specs;
    localStorage.setItem('specs', this.specs);
    if (this.Category === 'null' || this.Category == null) {
      this.Category = {};
      params.categoryslug = this.categorySlug;
    } else if (this.categorySlug === undefined) {
      params.categoryslug = '';
    } else {
      params.categoryslug = this.categorySlug;
    }
    if (this.priceFrom == null) {
      this.priceFrom = 1;
      params.priceFrom = this.priceFrom;
    } else {
      params.priceFrom = this.priceFrom;
    }
    if (isPlatformBrowser(this.platformId)) {
      if (!localStorage.getItem('priceTo')) {
        this.priceTo = '';
        params.priceTo = this.priceTo;
      } else {
        params.priceTo = this.priceTo;
      }
    }
    params.condition = this.condition;
    console.log(params)
    this.receiveProgress(params);
  }
  // Category Filter
  categoryFilter(i) {
    this.isMainCategoryLoading = true;
    this.Category = {};
    this.SideCategory = {};
    this.brands = [];
    const para = {
      categorySlug: i,
      settingsId: environment.settingsId,
      specialdeal: this.specialDealValue
    };
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.sortOrder = '';
    //params.specialdeal = 1;
    // this.listSandBox.getCategoryList(params);
    console.log('categoryFilter-->',i)
    this.listsService.getCategoryList(params).subscribe((res1: any) => {
      this.full_category = res1.data;
      res1.data = res1.data;
      console.log('Calling subcategory-->',i)
      this.listsService.getSubCategoryList(para)
        .subscribe((res: any) => {
          if (this.full_category.length > 0) {

            const filteredData = this.full_category.filter(res => res.categorySlug === i)
            // console.log('res 3',filteredData[0].children)
            // console.log('res 3',res.categoryDataId)
            console.log('res 3', this.full_category)
            res.categoryDataId = {
              ...res.categoryDataId,
              catChild: filteredData[0]?.children.sort((a, b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                return nameA.localeCompare(nameB); // Use localeCompare for string comparison
              })
            }

            this.Category = res.categoryDataId
            if (this.Category.parentInt === 0) {
              this.isProduct = true
            }
            else {
              this.isProduct = false
            }
          }

          // this.Category = res.categoryDataId
          this.brands = res?.brands
          this.isMainCategoryLoading = false;
          console.log('res 1', this.Category)
        });

        this.listsService.getSubCategoryList_new(para)
        .subscribe((res: any) => {
          console.log("para==========================================================2");
          console.log(para);
          if (this.full_category.length > 0) {

            const filteredData = this.full_category.filter(res => res.categorySlug === i)
            // console.log('res 3',filteredData[0].children)
            // console.log('res 3',res.categoryDataId)
            console.log('res 3', this.full_category)
            res.categoryDataId = {
              ...res.categoryDataId,
              catChild: filteredData[0]?.children.sort((a, b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                return nameA.localeCompare(nameB); // Use localeCompare for string comparison
              })
            }

            this.SideCategory = res.categoryDataId
            if (this.SideCategory.parentInt === 0) {
              this.isProduct = true
            }
            else {
              this.isProduct = false
            }
          }

          // this.Category = res.categoryDataId
          this.brands = res?.brands
          this.isMainCategoryLoading = false;
          console.log('res 1', this.SideCategory)
        });
    })

   
  }

  // subCategoryFilter(i) {
  //   if(i === '220-volt-major-applainces'){
  //     const params = {
  //       categorySlug: i,
  //       settingsId: environment.settingsId
  //     };
  //     this.listsService.getSubCategoryList(params)
  //       .subscribe((res: any) => {
  //         this.subCategory = res?.categoryDataId?.children1.sort((a, b) => {
  //       const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive comparison
  //       const nameB = b.name.toUpperCase();

  //       if (nameA < nameB) {
  //         return -1; // If nameA should appear before nameB
  //       }
  //       if (nameA > nameB) {
  //         return 1; // If nameA should appear after nameB
  //       }
  //       return 0; // If nameA and nameB are equivalent
  //     });
  //     console.log('res 2',this.subCategory)
  //       });

  //     //  this.subCategory =  this.rawSubCategory

  //   }  
  // }

  isChecked(manufacturerId: string) {
    if (this.brandIdarray.includes(manufacturerId)) {
      return true
    }
    else {
      false
    }
  }
  /**
   * fetch product list from service. calling getProductList function from sandbox
   *
   * @param limit number of records to be load
   * @param offset startkey of the records to be load
   * @param manufacturerId brand id to be filtered
   * @param categoryId category id to be filtered
   * @param price price to be filtered
   * @param priceFrom filter (from price)
   * @param keyword filter (to price)
   */
  getProductList(offset, price, category) {
    console.log("pricessssssss", offset, "///////", price, "**************", category)
    if (category && category.length > 1) {
      this.categoryFilter(category);
    }
    const params: any = {};
    params.limit = this.pagesize;
    params.offset = offset;
    if (this.brand == null) {
      this.brand = '';
    }
    params.manufacturerId = this.brand;
    params.categoryslug = category;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('categoryIdDataKey', this.categoryId);
    }
    params.keyword = this.keyword;
    params.price = price;
    if (this.priceFrom) {
      params.priceFrom = this.priceFrom;
    } else {
      params.priceFrom = 0;
    }
    if (this.condition) {
      params.condition = this.condition;
    }
    params.priceTo = this.priceTo;
    params.storename = this.storename;
    const specs: any = localStorage.getItem('specs');

    if (specs && specs !== undefined) {
      params.Specs = specs;
    }
    console.log(params)
    params.specialdeal = this.specialDealValue
    this.listSandbox.getProductList(params)
    params.price = '';
    params.count = true;
    params.specialdeal = this.specialDealValue
    this.listSandbox.getProductCount(params);
  }

  /**
   * open quick view of the product
   *
   * @param data passing selected product detail to dialog
   */
  public openProductDialog(product) {
    const dialogRef = this.dialog.open(ProductDialogComponent, {
      panelClass: 'product-dialog',
      data: product
    });
    dialogRef.afterClosed().subscribe(products => {
      if (products) {
        this.router.navigate(['/products/productdetails', products.productSlug]);
      }
    });
  }

  // sidebar open close based on the window size
  @HostListener('window:resize')
  public onWindowResize(): void {
    window.innerWidth < 960
      ? (this.sidenavOpen = false)
      : (this.sidenavOpen = true);
    window.innerWidth < 1280 ? (this.viewCol = 33.3) : (this.viewCol = 25);
  }

  // changing the view type
  public changeViewType(viewType, viewCol) {
    this.viewType = viewType;
    this.viewCol = viewCol;
  }

  // calls getProductList for sorting list
  public changeSorting(sort) {
    // this.sortData = sort.order;
    this.viewOrder = sort;
    this.getProductList(this.startKey, this.viewOrder, this.categorySlug);
  }

  // calls getProductList for pagination
  onPageChange(event) {
    console.log("event", event)
    this.startKey = event.pageSize * event.pageIndex;
    this.pagesize = event.pageSize;
    this.index = event.pageIndex;
    if (isPlatformBrowser(this.platformId)) {
      this.priceFrom = parseInt(localStorage.getItem('fromPrice'));
      this.priceTo = localStorage.getItem('priceTo');
    }

    if (this.priceTo == null) {
      this.priceTo = '';
    }

    this.getProductList(this.startKey, this.viewOrder, this.categorySlug);
  }

  /**
   *  receive data which is emitted from the child component through event emitter,
   * set's local storage value(brandKey). And calls getProductList.
   *
   *  @param event from event  emitter.
   *
   *  **/
  receiveProgress(event) {
    this.priceFrom = 0;
    this.brand = event?.manufacturerId;
    console.log(this.brand)
    // this.categoryId = event.categoryId;
    this.priceFrom = event?.priceFrom;
    this.priceTo = event?.priceTo;
    this.condition = event?.condition;
    const defaultCallValue = this.viewOrder;
    this.categorySlug = event?.categoryslug;
    this.specs = event?.Specs;
    if (this.categorySlug === 'All') {
      this.categorySlug = '';
    }
    this.startKey = 0;
    this.index = 0;
    this.getProductList(0, defaultCallValue, this.categorySlug);

  }


  toHTML(input): any {
    return new DOMParser().parseFromString(input, "text/html").documentElement.textContent;
  }



  calculatePrice(price: number, taxType: number, taxValue: number) {
    switch (taxType) {
      case 1:
        const priceWithOutTax = +price + taxValue;
        return Math.round(priceWithOutTax);
      case 2:
        const percentToAmount = price * (taxValue / 100);
        const priceWithTax = +price + percentToAmount;
        return Math.round(priceWithTax);
      default:
        return price;
    }
    // return price;
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj.Images).length === 0));
  }

  ngOnDestroy() {
    this.subscription.forEach(each => {
      each.unsubscribe();
    });
  }

  composeDesign(event) {
    this.showCompose = true;
    const pane = document.getElementsByClassName('cdk-overlay-pane');
    [].forEach.call(pane, function (el) {
      // if (el.children.length > 0) {
      //     if (el.children[0].classList.contains('mega-menu')) {
      el.classList.add('pagination-overlay-menu');
      //     }
      // }
    });
  }


  // COMPARE PAGE
  // add product for comparison
  addToCompare(event) {
    let isAdded = false;
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('compareId')) {
        this.selectedCompare = JSON.parse(localStorage.getItem('compareId'));
      }
    }
    if (this.selectedCompare.includes(event.productId)) {
      isAdded = true;
    }
    if (isAdded) {
      const ind = this.selectedCompare.indexOf(event.productId);
      const arr = this.selectedCompare.splice(ind, 1);
      this.selected = this.selectedCompare;
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('compareId', JSON.stringify(this.selectedCompare));
      }
      this.compareSandbox.addCompareCount(this.selectedCompare);
      this.showError('Product removed from compare');
      return;
    }
    // if (this.selectedCompare.length >= 4) {
    //   this.check = false
    //   this.showError('Cannot compare more than 4 products');

    //   return;
    // }
    this.selectedCompare.push(event.productId);
    this.selected = this.selectedCompare;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('compareId', JSON.stringify(this.selectedCompare));
    }
    // this.check = false

    const compare = this.selectedCompare.toString();
    this.compareProducts(compare);
  }
  compareProducts(products) {
    const compareParam: any = {};
    compareParam.data = 0;
    compareParam.productId = products;
    // this.compareSandbox.compareProducts(compareParam);
    this.productCompareService.comparePro(compareParam)
      .subscribe((res: any) => {
        if (res.status === 0) {
          // this.check = false
          if (this.selectedCompare.length >= 5) {
            this.showError('Cannot compare more than 4 products');
            const popped = this.selectedCompare.pop();
            localStorage.setItem('compareId', JSON.stringify(this.selectedCompare));
            this.selected = this.selectedCompare;
            return;
          } else {
            this.showError(res.message);
            const popped = this.selectedCompare.pop();
            localStorage.setItem('compareId', JSON.stringify(this.selectedCompare));
            this.selected = this.selectedCompare;
            this.compareSandbox.addCompareCount(this.selectedCompare);
          }

        } else {
          // this.check = true
          this.compareSandbox.addCompareCount(this.selectedCompare);
          this.selected = this.selectedCompare;
          this.showSuccess(res.message);
          // this.ngOnInit();
        }
      });
  }
  showError(message) {
    this.snackBar.open(message, '×', {
      panelClass: 'error',
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 3000
    });
  }
  showSuccess(message) {
    this.snackBar.open(message, '×', {
      panelClass: 'success',
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 3000
    });
  }

  comparedProducts() {
    this.router.navigate(['/compare']);
  }
  test(test:any){
console.log("testingggggg",test)
  }
  // reset(){
  //   window.location.reload();
  // }
}
